module.exports = __webpack_public_path__ + "img/magny_cours_cover.fd4f6590.jpg";